import { api_url } from "../../../utils";

const IngresoHogares = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=economia&schema_city=",
    zindex: 1,
    type: "graduated",
    popup: {
        default: {
            content: {
                es: {
                    nombre: "Nombre de la macrozona: ",
                    ingreso_ho: "Ingresos medios de los hogares (soles): ",
                    peso: "Peso del gasto mensual en transporte en el presupuesto familiar (%): ",
                },
            },
            separators: {
                decimal: ["peso"],
                thousand: ["ingreso_ho"],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.IngresoHogares",
    style: {
        regular: false,
        fillColor: "rgba(0, 0, 0)",
        strokeColor: "rgb(0, 0, 0)",
        strokeWidth: 0,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.IngresoHogares.title",
            subtitle: "",
            attribute: "ingreso_ho",
            symbol: "rectangle",
            legendCustomCssClass: "",
            class: [
                {
                    fillColor: "rgb(78, 153, 196)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 0,
                    max: 1999,
                    label: "Mobility Indicators Content.layersLegend.IngresoHogares.classes.1",
                },
                {
                    fillColor: "rgb(197, 242, 243)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 2000,
                    max: 2499,
                    label: "Mobility Indicators Content.layersLegend.IngresoHogares.classes.2",
                },
                {
                    fillColor: "rgb(253, 244, 159)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 2500,
                    max: 2999,
                    label: "Mobility Indicators Content.layersLegend.IngresoHogares.classes.3",
                },
                {
                    fillColor: "rgb(250, 222, 82)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 3000,
                    max: 3499,
                    label: "Mobility Indicators Content.layersLegend.IngresoHogares.classes.4",
                },
                {
                    fillColor: "rgb(239, 160, 133)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 3500,
                    max: 3600,
                    label: "Mobility Indicators Content.layersLegend.IngresoHogares.classes.5",
                },
            ],
        },
    },
};

export default IngresoHogares;
